import { DatatableCell, Skeleton } from '@monksflow/monks-ui';
import { TableSkeletonActionsCell, TableSkeletonRow } from '@/shared/ui/data-table';

/**
 * Loading placeholder mirroring the SHAPE of a real template row — leading icon badge + name, then
 * a short date — so the skeleton reads as a table rather than a block of grey bars. Column order
 * and widths track {@link EmailTemplatesTable}'s header.
 */
export const EmailTemplatesTableSkeletonRow = () => (
  <TableSkeletonRow testId="email-templates-table-skeleton-row">
    <DatatableCell>
      <div className="flex items-center gap-3">
        <Skeleton className="size-10 rounded-lg" />
        <Skeleton className="h-4 w-40" />
      </div>
    </DatatableCell>

    <DatatableCell>
      <Skeleton className="h-4 w-24" />
    </DatatableCell>

    {/* Balancing spacer — matches the header/row spacer (see EmailTemplatesTable). */}
    <DatatableCell aria-hidden />

    <TableSkeletonActionsCell />
  </TableSkeletonRow>
);

EmailTemplatesTableSkeletonRow.displayName = 'EmailTemplatesTableSkeletonRow';
